import ResultParameter from "../ResultParameter";
import SystemSettings from "../SystemSettings";
import Session from "../Session";
import LoginRequest from "../LoginRequest";
import ForgotPasswordRequest from "../ForgotPasswordRequest";
import UpdatePasswordRequest from "../UpdatePasswordRequest";
import IgbModelSearchRequest from "../IgbModelSearchRequest";
import IgbModelSearchResponse from "../IgbModelSearchResponse";
import PersonSearchRequest from "../PersonSearchRequest";
import PersonSearchResponse from "../PersonSearchResponse";
import TenantSearchRequest from "../TenantSearchRequest";
import TenantSearchResponse from "../TenantSearchResponse";
import LocationSearchRequest from "../LocationSearchRequest";
import LocationSearchResponse from "../LocationSearchResponse";
import LocationGroupSearchRequest from "../LocationGroupSearchRequest";
import LocationGroupSearchResponse from "../LocationGroupSearchResponse";
import RevenuePaymentSearchRequest from "../RevenuePaymentSearchRequest";
import RevenuePaymentSearchResponse from "../RevenuePaymentSearchResponse";
import RevenuePayPeriodSearchRequest from "../RevenuePayPeriodSearchRequest";
import RevenuePayPeriodSearchResponse from "../RevenuePayPeriodSearchResponse";
import RevenueReimbursementSearchRequest from "../RevenueReimbursementSearchRequest";
import RevenueReimbursementSearchResponse from "../RevenueReimbursementSearchResponse";
import CashAccountSearchRequest from "../CashAccountSearchRequest";
import CashAccountSearchResponse from "../CashAccountSearchResponse";
import CashCollectionSearchRequest from "../CashCollectionSearchRequest";
import CashCollectionSearchResponse from "../CashCollectionSearchResponse";
import CashCollectionDepositRequest from "../CashCollectionDepositRequest";
import CashCollectionReverseDepositRequest from "../CashCollectionReverseDepositRequest";
import CashTransferSearchRequest from "../CashTransferSearchRequest";
import CashTransferSearchResponse from "../CashTransferSearchResponse";
import CashProcessingBatchSearchRequest from "../CashProcessingBatchSearchRequest";
import CashProcessingBatchSearchResponse from "../CashProcessingBatchSearchResponse";
import RtReconciliationSearchUnmatchedRequest from "../RtReconciliationSearchUnmatchedRequest";
import RtReconciliationSearchUnmatchedResponse from "../RtReconciliationSearchUnmatchedResponse";
import RtReconciliationSearchMatchedRequest from "../RtReconciliationSearchMatchedRequest";
import RtReconciliationSearchMatchedResponse from "../RtReconciliationSearchMatchedResponse";
import RtReconciliationUploadRtReportRequest from "../RtReconciliationUploadRtReportRequest";
import RtReconciliationUploadRtReportError from "../RtReconciliationUploadRtReportError";
import ReconciliationLineItem from "../ReconciliationLineItem";
import ReconciliationItem from "../ReconciliationItem";
import VgtSetMeterRequest from "../VgtSetMeterRequest";
import VaultSetUsersRequest from "../VaultSetUsersRequest";
import CollectionDashboardResponse from "../CollectionDashboardResponse";
import CollectionLocationActivity from "../CollectionLocationActivity";
import IgbModel from "../IgbModel";
import County from "../County";
import RevenuePerformanceOverTimeResponse from "../RevenuePerformanceOverTimeResponse";
import RevenueSummaryResponse from "../RevenueSummaryResponse";
import VgtPerformanceMetric from "../VgtPerformanceMetric";
import LineGraph from "../LineGraph";
import GraphMetric from "../GraphMetric";
import GraphItem from "../GraphItem";
import Location from "../Location";
import LocationGroup from "../LocationGroup";
import ReportedVgtMachine from "../ReportedVgtMachine";
import PayPeriod from "../PayPeriod";
import Payment from "../Payment";
import Reimbursement from "../Reimbursement";
import Tenant from "../Tenant";
import TenantPreferences from "../TenantPreferences";
import TenantMembership from "../TenantMembership";
import CashAccount from "../CashAccount";
import CashAccountMachineRecordDetails from "../CashAccountMachineRecordDetails";
import CashAccountBankDetails from "../CashAccountBankDetails";
import CashAccountVaultDetails from "../CashAccountVaultDetails";
import CashAccountOffageDetails from "../CashAccountOffageDetails";
import CashProcessingBatch from "../CashProcessingBatch";
import CashProcessingLineItem from "../CashProcessingLineItem";
import CashCollection from "../CashCollection";
import CashTransfer from "../CashTransfer";
import Person from "../Person";
import OwnerDetails from "../OwnerDetails";
import UserDetails from "../UserDetails";
import AmountDetails from "../AmountDetails";
import VaultAmountDetails from "../VaultAmountDetails";
import VaultReportedAmount from "../VaultReportedAmount";
import FileAsset from "../FileAsset";

class ModelProxyClass {
	/**
	 * Constructs a model-based BaseClass subclass based on the className
	 * @param {string} className
	 * @param {object} genericObject
	 * @return {ModelBaseClass}
	 */
	static createByClassName(className, genericObject) {
		switch (className) {
		case 'ResultParameter':
			return ResultParameter.create(genericObject);
		case 'SystemSettings':
			return SystemSettings.create(genericObject);
		case 'Session':
			return Session.create(genericObject);
		case 'LoginRequest':
			return LoginRequest.create(genericObject);
		case 'ForgotPasswordRequest':
			return ForgotPasswordRequest.create(genericObject);
		case 'UpdatePasswordRequest':
			return UpdatePasswordRequest.create(genericObject);
		case 'IgbModelSearchRequest':
			return IgbModelSearchRequest.create(genericObject);
		case 'IgbModelSearchResponse':
			return IgbModelSearchResponse.create(genericObject);
		case 'PersonSearchRequest':
			return PersonSearchRequest.create(genericObject);
		case 'PersonSearchResponse':
			return PersonSearchResponse.create(genericObject);
		case 'TenantSearchRequest':
			return TenantSearchRequest.create(genericObject);
		case 'TenantSearchResponse':
			return TenantSearchResponse.create(genericObject);
		case 'LocationSearchRequest':
			return LocationSearchRequest.create(genericObject);
		case 'LocationSearchResponse':
			return LocationSearchResponse.create(genericObject);
		case 'LocationGroupSearchRequest':
			return LocationGroupSearchRequest.create(genericObject);
		case 'LocationGroupSearchResponse':
			return LocationGroupSearchResponse.create(genericObject);
		case 'RevenuePaymentSearchRequest':
			return RevenuePaymentSearchRequest.create(genericObject);
		case 'RevenuePaymentSearchResponse':
			return RevenuePaymentSearchResponse.create(genericObject);
		case 'RevenuePayPeriodSearchRequest':
			return RevenuePayPeriodSearchRequest.create(genericObject);
		case 'RevenuePayPeriodSearchResponse':
			return RevenuePayPeriodSearchResponse.create(genericObject);
		case 'RevenueReimbursementSearchRequest':
			return RevenueReimbursementSearchRequest.create(genericObject);
		case 'RevenueReimbursementSearchResponse':
			return RevenueReimbursementSearchResponse.create(genericObject);
		case 'CashAccountSearchRequest':
			return CashAccountSearchRequest.create(genericObject);
		case 'CashAccountSearchResponse':
			return CashAccountSearchResponse.create(genericObject);
		case 'CashCollectionSearchRequest':
			return CashCollectionSearchRequest.create(genericObject);
		case 'CashCollectionSearchResponse':
			return CashCollectionSearchResponse.create(genericObject);
		case 'CashCollectionDepositRequest':
			return CashCollectionDepositRequest.create(genericObject);
		case 'CashCollectionReverseDepositRequest':
			return CashCollectionReverseDepositRequest.create(genericObject);
		case 'CashTransferSearchRequest':
			return CashTransferSearchRequest.create(genericObject);
		case 'CashTransferSearchResponse':
			return CashTransferSearchResponse.create(genericObject);
		case 'CashProcessingBatchSearchRequest':
			return CashProcessingBatchSearchRequest.create(genericObject);
		case 'CashProcessingBatchSearchResponse':
			return CashProcessingBatchSearchResponse.create(genericObject);
		case 'RtReconciliationSearchUnmatchedRequest':
			return RtReconciliationSearchUnmatchedRequest.create(genericObject);
		case 'RtReconciliationSearchUnmatchedResponse':
			return RtReconciliationSearchUnmatchedResponse.create(genericObject);
		case 'RtReconciliationSearchMatchedRequest':
			return RtReconciliationSearchMatchedRequest.create(genericObject);
		case 'RtReconciliationSearchMatchedResponse':
			return RtReconciliationSearchMatchedResponse.create(genericObject);
		case 'RtReconciliationUploadRtReportRequest':
			return RtReconciliationUploadRtReportRequest.create(genericObject);
		case 'RtReconciliationUploadRtReportError':
			return RtReconciliationUploadRtReportError.create(genericObject);
		case 'ReconciliationLineItem':
			return ReconciliationLineItem.create(genericObject);
		case 'ReconciliationItem':
			return ReconciliationItem.create(genericObject);
		case 'VgtSetMeterRequest':
			return VgtSetMeterRequest.create(genericObject);
		case 'VaultSetUsersRequest':
			return VaultSetUsersRequest.create(genericObject);
		case 'CollectionDashboardResponse':
			return CollectionDashboardResponse.create(genericObject);
		case 'CollectionLocationActivity':
			return CollectionLocationActivity.create(genericObject);
		case 'IgbModel':
			return IgbModel.create(genericObject);
		case 'County':
			return County.create(genericObject);
		case 'RevenuePerformanceOverTimeResponse':
			return RevenuePerformanceOverTimeResponse.create(genericObject);
		case 'RevenueSummaryResponse':
			return RevenueSummaryResponse.create(genericObject);
		case 'VgtPerformanceMetric':
			return VgtPerformanceMetric.create(genericObject);
		case 'LineGraph':
			return LineGraph.create(genericObject);
		case 'GraphMetric':
			return GraphMetric.create(genericObject);
		case 'GraphItem':
			return GraphItem.create(genericObject);
		case 'Location':
			return Location.create(genericObject);
		case 'LocationGroup':
			return LocationGroup.create(genericObject);
		case 'ReportedVgtMachine':
			return ReportedVgtMachine.create(genericObject);
		case 'PayPeriod':
			return PayPeriod.create(genericObject);
		case 'Payment':
			return Payment.create(genericObject);
		case 'Reimbursement':
			return Reimbursement.create(genericObject);
		case 'Tenant':
			return Tenant.create(genericObject);
		case 'TenantPreferences':
			return TenantPreferences.create(genericObject);
		case 'TenantMembership':
			return TenantMembership.create(genericObject);
		case 'CashAccount':
			return CashAccount.create(genericObject);
		case 'CashAccountMachineRecordDetails':
			return CashAccountMachineRecordDetails.create(genericObject);
		case 'CashAccountBankDetails':
			return CashAccountBankDetails.create(genericObject);
		case 'CashAccountVaultDetails':
			return CashAccountVaultDetails.create(genericObject);
		case 'CashAccountOffageDetails':
			return CashAccountOffageDetails.create(genericObject);
		case 'CashProcessingBatch':
			return CashProcessingBatch.create(genericObject);
		case 'CashProcessingLineItem':
			return CashProcessingLineItem.create(genericObject);
		case 'CashCollection':
			return CashCollection.create(genericObject);
		case 'CashTransfer':
			return CashTransfer.create(genericObject);
		case 'Person':
			return Person.create(genericObject);
		case 'OwnerDetails':
			return OwnerDetails.create(genericObject);
		case 'UserDetails':
			return UserDetails.create(genericObject);
		case 'AmountDetails':
			return AmountDetails.create(genericObject);
		case 'VaultAmountDetails':
			return VaultAmountDetails.create(genericObject);
		case 'VaultReportedAmount':
			return VaultReportedAmount.create(genericObject);
		case 'FileAsset':
			return FileAsset.create(genericObject);
		default:
			throw new Error('Undefined model class: ' + className);
		}
	}
}

export default ModelProxyClass;
